<template>
	<h1 class="itv-page-title" :title="content" v-html="content"></h1>
</template>

<script>
export default {
	name: 'PageTitle',
	props: {
		content: {
			type: String,
			default: '',
		},
	},
}
</script>
